module.exports = __webpack_public_path__ + "assets/images/project/satellite-images/meta-2017-desktop.jpg?v=b97d0e15";